import audios from 'a/assets/audio';
import useAudioPlayer from 'root/lib/hooks/useAudioPlayer';

const useGlobalSfx = () => {
  const { playAudio } = useAudioPlayer();
  const play = (src, config = {}) => playAudio({ src, continuePlayingAfterUnmount: true, interrupt: true, ...config });
  return {
    click: (config) => play(audios.click, config),
    slide: (config) => play(audios.slide, config),
    pop: (config) => play(audios.pop, config),
    tap: (config) => play(audios.tap, config),
    levelMastery45: (config) => play(audios.levelMastery45, config),
    levelMasteryK3: (config) => play(audios.levelMasteryK3, config),
    analyzing: (config) => play(audios.analyzing, config),
    stop: (config) => play(audios.stop, config),
    correctFeedback: (config) => play(audios.correctFeedback, config),
    incorrectFeedback: (config) => play(audios.incorrectFeedback, config),
    playAudio,
  };
};

export default useGlobalSfx;
